import React, { useEffect, useState } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Alert } from "reactstrap";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import {
    resetGetViewConfigurationList,
    getViewConfigurationAdminList
} from "../../redux/actions/getViewConfigurationAdminAction";
import Layout from "../../components/Wrappers/Layout";
import Autocomplete from "@mui/lab/Autocomplete";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Box,
    withWidth, FormControl
} from "@mui/material";
import { makeStyles } from "@mui/styles";
// import {
//     MuiPickersUtilsProvider,
//     DatePicker
// } from "@mui/material/pickers";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import FormControl from "@mui/material/FormControl";
import BackButton from "../../components/BackButton/BackButton";
import { getModuleNameList } from "../../redux/actions/getModuleNameListAdminAction"
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { getUpdateUserActivityLog, resetGetUserActivityLog } from "../../redux/actions/getUserActivityLogAdminAction";
import { partnerGetSubModuleNameList } from "../../redux/actions/getSubModuleListPartnerAction"
import { getCode } from "../../utils/countries";
import val from "../../getThemeDetails";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});



function ActivityTrackerAdmin() {
    const [getActivityLogArrayList, setGetActivityLogArrayList] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);
    const [partnerId, setpartnerId] = useState('');
    const [getWalletManagement, setGetWalletManagement] = useState("");
    var date = new Date();
    const [selectedDate, setSelectedDate] = useState(
        new Date(date.getFullYear(), date.getMonth(), 1)
    );
    const [selectedToDate, setSelectedToDate] = useState(new Date());
    const [SubModuleName, setSubModuleName] = useState("");
    const [uname, setuname] = useState("");
    const classes = useStyles();
    const [walletOwnerTableStatus, setWalletOwnerTableStatus] = useState(false);
    const [walletOwnerTableArray, setWalletOwnerTableArray] = useState([]);
    const [retryModuleList, setRetryModuleList] = useState(false);
    const [retrySubModuleList, setRetrySubModuleList] = useState(false);
    // THIS IS FOR PEGINATION---
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };


    //AUTH TOKEN GENRATE
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    const getSubModuleNameListRes = useSelector(
        ({ submodulenamelist }) => submodulenamelist);

    // var authToken = regenerateTokenRes.data.AuthToken;
    const authToken = regenerateTokenRes.data?.AuthToken || "";

    const dispatch = useDispatch();

    // THIS IS FOR MODULE NAME AND LIST DROPDOWN
    const getModulNamelistDropDown = useSelector(
        ({ adminGetModuleNameLists }) => adminGetModuleNameLists
    );

    const modulenameListFunc = () => {
        const moduleNameListRequest = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: "1",
            }
        }
        return dispatch(getModuleNameList(moduleNameListRequest, authToken))
    }
  
    useEffect(() => {
        modulenameListFunc();
    }, [])

    const submodulenameListFunc = (ModuleName) => {
        const submoduleNameListRequest = {
            actionCustomerMasterRequestVO: {
                walletOwnerId: partnerId,
                moduleName: ModuleName !== "Select Module Name" ? ModuleName : "",
            }
        }
        return dispatch(partnerGetSubModuleNameList(submoduleNameListRequest, authToken))
    }





 


    useEffect(() => {
        submodulenameListFunc();
    }, [])

    const getAdminUserActivityLogList = useSelector(
        ({ adminUserActivityLogList }) => adminUserActivityLogList);



    // THIS IS FOR OWNER ID DROP DOWN..
    const getWalletOwnerIdRes = useSelector(
        ({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
    );

    const getWalletOwnerIdAndNameListFun = () => {
        setIsLoading(true);
        setWalletOwnerTableStatus(true);

        const getWalletOwnerIdAndNameListReq = {
            loginDetails: {
                // adminId: "2"
                adminId: val.adminIDS
            }
        }
        return dispatch(getWalletOwnerIdAndNameList(getWalletOwnerIdAndNameListReq, authToken))
    }


    useEffect(() => {
        // Initial fetch of wallet owner list when component mounts
        // This will happen only once unless dependencies change
        if (authToken) { // Only dispatch if authToken is available
            getWalletOwnerIdAndNameListFun();
        }
    }, [authToken]); // Dependency on authToken to re-run if token changes


    useEffect(() => {
        console.log("made get req for getOwnerAndNameList");
        if (walletOwnerTableStatus) { // Check if the request was actually made
            if (getWalletOwnerIdRes.data.status === "success") {
                setIsLoading(false);
                setWalletOwnerTableArray([].concat(getWalletOwnerIdRes.data.ownerList));
            } else if (getWalletOwnerIdRes.data.status === "failed") {
                setIsLoading(false);
                setWalletOwnerTableArray([]); // Clear array on failure
                if (getWalletOwnerIdRes.data.description === "session out") {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                } else if (getWalletOwnerIdRes.data.description === "Authorization failed") {
                    // This is the key change: dispatch regenerateToken
                    // The subsequent useEffect will handle re-fetching after regeneration
                    dispatch(regenerateToken(authToken, regenerateTokenRes.data.partnerId));
                }
            }
        }
    }, [getWalletOwnerIdRes, walletOwnerTableStatus, dispatch, authToken, regenerateTokenRes.data.partnerId]);

    // Effect to handle regenerateToken success and then re-call getWalletOwnerIdAndNameListTableRequest
    useEffect(() => {
        if (regenerateTokenRes.status === "success" && regenerateTokenRes.data.AuthToken) {
            console.log("Token regenerated successfully, re-fetching wallet owner list.");
            // Re-call the function to fetch wallet owner list with the new token
            getWalletOwnerIdAndNameListFun();
        } else if (regenerateTokenRes.status === "failed") {
            // Handle regenerate token failure (e.g., show an error message, force logout)
            console.error("Token regeneration failed:", regenerateTokenRes.error);
            // Optionally, you might want to log out the user here if token regeneration consistently fails
            SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId); // Example: force logout on regeneration failure
        }
    }, [regenerateTokenRes.status, regenerateTokenRes.data.AuthToken, dispatch, authToken, regenerateTokenRes.data.partnerId]);
    // useEffect(() => {
    //     getWalletOwnerIdAndNameListFun()
    // }, [])


    // THIS IS FOR SET CALENDER VAL
    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleToDateChange = (date) => {
        setSelectedToDate(date);
    };

    // THIS IS FOR SET VAL MODULE NAME &OWNER ID..

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        if (name === "partnerId") {
            setpartnerId(value);
        }
        if (name === "ModuleName") {
            setGetWalletManagement(value);
            if (value) {
                submodulenameListFunc(value);
            }
        }
        if (name === "subModuleName") {
            setSubModuleName(value);
        }
        if (name === "uname") {
            setuname(value);
        }

    }


    // THIS FUNCTION IS USE FOR CALL (getUserActivityLog) API..

    const fetchActivityTrackerData = () => {
        // console.log("partneSSSSID", partnerId)
        setIsLoading(true);
        const getActivityLogReq = {

            actionCustomerMasterRequestVO: {
                fromDate: moment(selectedDate).format("DD/MM/YYYY"),
                toDate: moment(selectedToDate).format("DD/MM/YYYY"),
                moduleName: getWalletManagement !== "Select Module Name" ? getWalletManagement : "",
                walletOwnerId: partnerId.split("-")[0] || "",
                // walletOwnerId: partnerId,

                subModuleName: SubModuleName !== "Select Module Name" ? SubModuleName : "",
                userName: uname ? uname.split('-')[1] : '',
            }

        };
        // console.log("reqqq",getActivityLogReq)
        return dispatch(getUpdateUserActivityLog(getActivityLogReq, authToken)
        );
    };

    // THIS FUNCTION IS USE FOR CALL (getUserActivityLog) API..RESPONCE

    const getUserActivityLogResp = () => {
        if (getAdminUserActivityLogList.data && getAdminUserActivityLogList.data.status === "SUCCESS") {
            setIsLoading(false);
            setGetActivityLogArrayList(
                [].concat(getAdminUserActivityLogList.data.userActivityLog)
            );
        }
        if (getAdminUserActivityLogList.data.status == "FAILED") {
            setIsLoading(false);
            setGetActivityLogArrayList(getAdminUserActivityLogList);
            if (
                getAdminUserActivityLogList.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (getAdminUserActivityLogList.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }

    useEffect(() => {
        getUserActivityLogResp();
    }, [getAdminUserActivityLogList]);

    const getSubModuleNameListResp = () => {
        if (getSubModuleNameListRes.data && getSubModuleNameListRes.data.status === "SUCCESS") {
            setIsLoading(false);
        }
        if (getSubModuleNameListRes.data.status == "FAILED") {
            setIsLoading(false);
            if (
                getSubModuleNameListRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (getSubModuleNameListRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);

            }
        }
    }
    useEffect(() => {
        getSubModuleNameListResp();
    }, [getSubModuleNameListRes]);

    
    // THIS  ACTION IS RESET THE DATA FIRST TIME PAGE IS LOAD
    useEffect(() => {
        dispatch(resetGetUserActivityLog())
        return () => {
            dispatch(resetGetUserActivityLog())
        }
    }, []);

    const filterOptions = (options, { inputValue }) => {
        //console.log(options, inputValue, "optionsss")
        if (inputValue.length <= 1) {
            return [];
        }

        const filterOptionsList = options.filter(
            (option) =>
                option.includes(inputValue) ||
                ""
        );

        return filterOptionsList.slice(0, 20);
    }
    function coutnryFlag(cName) {
        const CoutryCode = getCode(cName);

        if (!CoutryCode) {
            return null;
        }
        let country;
        try {
            country = require(`../../assets/img/CountryFlags/${CoutryCode.toLowerCase()}.png`);
        } catch (err) {
            return null;
        }
        return country;
    }



    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <FormControl fullWidth>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="From Date"
                                        format="MM/dd/yyyy"
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        disableFuture={true}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <FormControl fullWidth>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="To Date"
                                        format="MM/dd/yyyy"
                                        value={selectedToDate}
                                        onChange={handleToDateChange}
                                        disableFuture={true}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    getModulNamelistDropDown.data.userName || [""]
                                )}
                                getOptionLabel={(option) => option}
                                filterOptions={filterOptions}
                                value={uname}
                                //onChange={handleChange}
                                onInputChange={(event, newInputValue) => {
                                    setuname(newInputValue);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        label="User Name"
                                        variant="standard"
                                        name="uname"
                                        id="uname"
                                        style={{ marginTop: "3px" }}
                                        {...params}
                                        fullwidth
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                variant="standard"
                                type="text"
                                label="Module Name"
                                style={{ marginTop: "6px" }}
                                fullWidth={true}
                                name="ModuleName"
                                defaultValue={"Select Module Name" || getWalletManagement}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Module Name" selected="Select Module Name">
                                    Select Module Name
                                </MenuItem>
                                {getModulNamelistDropDown.data.moduleName &&
                                    getModulNamelistDropDown.data.moduleName.map((x) => (
                                        <MenuItem value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={3} lg={3}>
                            <TextField
                                select
                                size="small"
                                color="primary"
                                type="text"
                                label="Sub Module Name"
                                style={{ marginTop: "6px" }}
                                fullWidth={true}
                                name="subModuleName"
                                defaultValue={"Select Module Name" || SubModuleName}
                                onChange={handleChange}
                                variant="standard"
                            >
                                <MenuItem value="Select Module Name" selected="Select Module Name">
                                    Select Sub Module Name
                                </MenuItem>
                                {getSubModuleNameListRes.data.moduleName &&
                                    getSubModuleNameListRes.data.moduleName.map((x) => (
                                        <MenuItem value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <TextField
                                select
                                required
                                size="small"
                                color="primary"
                                type="text"
                                variant="standard"
                                style={{ marginTop: "6px" }}
                                label="Owner ID"
                                fullWidth={true}
                                name="partnerId"
                                defaultValue={"Select Owner Id" || partnerId}
                                onChange={handleChange}

                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>

                                {/* {getWalletOwnerIdRes.data.ownerList &&
                                    getWalletOwnerIdRes.data.ownerList.map((x) => (
                                        <MenuItem value={x.split("-")[0]}>{x}</MenuItem>
                                    ))} */}

                                {getWalletOwnerIdRes.data.ownerList &&
                                    getWalletOwnerIdRes.data.ownerList &&
                                    []
                                        .concat(getWalletOwnerIdRes.data.ownerList)
                                        .map((dropdown) => (
                                            <MenuItem value={dropdown}>{dropdown}</MenuItem>
                                        ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px"
                                }}
                                onClick={fetchActivityTrackerData}
                            >
                                Search <SearchIcon />
                            </CustomButton>
                        </Grid>
                    </Grid>


                </Card>
                {isLoading ? (
                    <LoadingSpinner />
                ) : getActivityLogArrayList.length === undefined ||
                    getActivityLogArrayList.length === 0 ||
                    getActivityLogArrayList.status === "NOT FOUND" ||
                    getActivityLogArrayList.status === "FAILED" ||
                    !getActivityLogArrayList ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) :
                    (
                        <div>
                            <Card>
                                <Grid
                                    container
                                    style={{
                                        padding: "10px"
                                    }}
                                >
                                    <Grid xs={12} sm={12} md={12} lg={12}>
                                        <Typography
                                            variant="body1"
                                            style={{ fontWeight: "700" }}
                                            className="themeText"
                                        >
                                            Activity Details
                                        </Typography>
                                    </Grid>
                                    <TableContainer component={Paper} className="my-3">
                                        <Table className={classes.table}>
                                            <TableHead>
                                                <TableRow className="tableHeaderColor">

                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Wallet Owner Id{" "}
                                                    </TableCell>

                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        {" "}
                                                        Role
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        {" "}
                                                        User Name
                                                    </TableCell>

                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Module Name
                                                    </TableCell>

                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Sub Module Name
                                                    </TableCell>

                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        {" "}
                                                        IP Address
                                                    </TableCell>

                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Date
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Activity Type
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ fontWeight: "bold", color: "white" }}
                                                    >
                                                        Activity Description
                                                    </TableCell>

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {getActivityLogArrayList &&
                                                    []
                                                        .concat(getActivityLogArrayList)
                                                        .slice(
                                                            page * rowsPerPage,
                                                            page * rowsPerPage + rowsPerPage
                                                        )
                                                        .map((row, index) => (
                                                            <TableRow key={index}>

                                                                <TableCell align="center">{row.walletOwnerId}</TableCell>
                                                                <TableCell align="center">{row.role}</TableCell>
                                                                <TableCell align="center">{row.userName}</TableCell>
                                                                <TableCell align="center">{row.moduleName}</TableCell>
                                                                <TableCell align="center">{row.subModuleName}</TableCell>
                                                                <TableCell align="center">{row.ipCountry && row.ipCountry !== ("" || "-") ? (<img src={coutnryFlag(row.ipCountry)} style={{ height: "20px", width: "20px", marginRight: "10px" }} alt="" />) : null}{row.ipAddress}</TableCell>
                                                                <TableCell align="center">{row.registeredTime}</TableCell>
                                                                <TableCell align="center">{row.activityType}</TableCell>
                                                                <TableCell align="center">{row.activityDescription}</TableCell>
                                                            </TableRow>
                                                        ))}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25]}
                                            component="div"
                                            count={[].concat(getActivityLogArrayList).length}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                        />

                                    </TableContainer>

                                </Grid>
                            </Card>
                        </div>
                    )}

            </Layout>

        </>
    )
}

export default ActivityTrackerAdmin